"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.widths = exports.viewports = exports.constraintsByViewport = exports.constraints = exports.BREAKPOINTS = exports.BREAKPOINT_QUERIES = exports.widthKeysDesc = exports.widthKeys = void 0;
const utils_1 = require("./utils");
const viewports = {
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
    LARGE: 'LARGE',
};
exports.viewports = viewports;
/**
 * Map of viewport keys [widthKeys] to minWidth values.
 * @todo in TS v4.9+ declare `as const satisfies Readonly<Record<Key, Value>>>` instead of using typeCheckedFreeze()
 */
const widths = (0, utils_1.typeCheckedFreeze)()({
    [viewports.SMALL]: 0,
    [viewports.MEDIUM]: 640,
    [viewports.LARGE]: 1025,
});
exports.widths = widths;
/** Sorted ascending (smallest minWidth to largest). */
exports.widthKeys = Object.freeze(Object.values(viewports).sort((a, b) => widths[a] - widths[b]));
/** Sorted descending (largest minWidth to smallest). */
exports.widthKeysDesc = Object.freeze([...exports.widthKeys].reverse());
const constraints = Object.freeze(exports.widthKeys.map((key) => Object.freeze({ viewport: key, minWidth: widths[key] })));
exports.constraints = constraints;
const constraintsByViewport = Object.freeze(Object.fromEntries(constraints.map((constraint) => [constraint.viewport, constraint])));
exports.constraintsByViewport = constraintsByViewport;
/** @todo in TS v4.9+ declare `as const satisfies Readonly<Record<Key, Value>>>` instead of using typeCheckedFreeze() */
const breakpoints = (0, utils_1.typeCheckedFreeze)()({
    xs: { minWidth: 0, maxWidth: 320 },
    sm: { minWidth: 321, maxWidth: 639 },
    md: { minWidth: 640, maxWidth: 1024 },
    lg: { minWidth: 1025, maxWidth: 1219 },
    xl: { minWidth: 1220, maxWidth: 1599 },
    x2l: { minWidth: 1600, maxWidth: 1919 },
    x3l: { minWidth: 1920, maxWidth: 2399 },
    x4l: { minWidth: 2400 },
});
const BREAKPOINTS = new utils_1.ConstantMap(breakpoints);
exports.BREAKPOINTS = BREAKPOINTS;
/** @todo in TS v4.9+ declare `as const satisfies Readonly<Record<Key, Value>>>` instead of using typeCheckedFreeze() */
const breakpointQueries = (0, utils_1.typeCheckedFreeze)()({
    xs: `(min-width: ${breakpoints.xs.minWidth}px)`,
    'xs only': `(min-width: ${breakpoints.xs.minWidth}px) and (max-width: ${breakpoints.xs.maxWidth}px)`,
    sm: `(min-width: ${breakpoints.sm.minWidth}px)`,
    'sm only': `(min-width: ${breakpoints.sm.minWidth}px) and (max-width: ${breakpoints.sm.maxWidth}px)`,
    'xs to sm only': `(min-width: ${breakpoints.xs.minWidth}px) and (max-width: ${breakpoints.sm.maxWidth}px)`,
    md: `(min-width: ${breakpoints.md.minWidth}px)`,
    'md only': `(min-width: ${breakpoints.md.minWidth}px) and (max-width: ${breakpoints.md.maxWidth}px)`,
    'xs to md only': `(min-width: ${breakpoints.xs.minWidth}px) and (max-width: ${breakpoints.md.maxWidth}px)`,
    lg: `(min-width: ${breakpoints.lg.minWidth}px)`,
    'lg only': `(min-width: ${breakpoints.lg.minWidth}px) and (max-width: ${breakpoints.lg.maxWidth}px)`,
    'md to lg only': `(min-width: ${breakpoints.md.minWidth}px) and (max-width: ${breakpoints.lg.maxWidth}px)`,
    xl: `(min-width: ${breakpoints.xl.minWidth}px)`,
    'xl only': `(min-width: ${breakpoints.xl.minWidth}px) and (max-width: ${breakpoints.xl.maxWidth}px)`,
    'lg to xl only': `(min-width: ${breakpoints.lg.minWidth}px) and (max-width: ${breakpoints.xl.maxWidth}px)`,
    'lg to x2l only': `(min-width: ${breakpoints.lg.minWidth}px) and (max-width: ${breakpoints.x2l.maxWidth}px)`,
    'xs to xl only': `(min-width: ${breakpoints.xs.minWidth}px) and (max-width: ${breakpoints.xl.maxWidth}px)`,
    x2l: `(min-width: ${breakpoints.x2l.minWidth}px)`,
    x3l: `(min-width: ${breakpoints.x3l.minWidth}px)`,
    x4l: `(min-width: ${breakpoints.x4l.minWidth}px)`,
});
const BREAKPOINT_QUERIES = new utils_1.ConstantMap(breakpointQueries);
exports.BREAKPOINT_QUERIES = BREAKPOINT_QUERIES;
//# sourceMappingURL=viewports.js.map